<template>
    <div class="about-client">
         <div class="container">
             <h2 class="text-center">合作客户</h2>
            <el-row :gutter="20">
                <el-col :span="4" v-for="client in clients" :key="client.index">
                    <div class="client-pic">
                        <img :src="client.src" :title="client.title">
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
  // Import Swiper styles
export default {
    data() {
        return {
            clients: [{
                title: '客户一',
                src: require('../../../assets/img/partner/p_1.jpg')
                }, {
                title: '客户二',
                src: require('../../../assets/img/partner/p_2.jpg')
                }, {
                title: '客户三',
                src: require('../../../assets/img/partner/p_3.jpg')
                }, {
                title: '客户四',
                src: require('../../../assets/img/partner/p_4.jpg')
                }, {
                title: '客户五',
                src: require('../../../assets/img/partner/p_5.jpg')
                }, {
                title: '客户六',
                src: require('../../../assets/img/partner/p_6.jpg')
                }, {
                title: '客户七',
                src: require('../../../assets/img/partner/p_7.jpg')
                }, {
                title: '客户八',
                src: require('../../../assets/img/partner/p_8.jpg')
                }, {
                title: '客户九',
                src: require('../../../assets/img/partner/p_9.jpg')
                }, {
                title: '客户十',
                src: require('../../../assets/img/partner/p_10.jpg')
                }, {
                title: '客户十一',
                src: require('../../../assets/img/partner/p_11.jpg')
                }, {
                title: '客户12',
                src: require('../../../assets/img/partner/p_12.jpg')
                }, {
                title: '客户十三',
                src: require('../../../assets/img/partner/p_13.jpg')
                }, {
                title: '客户十四',
                src: require('../../../assets/img/partner/p_14.jpg')
                }, {
                title: '客户十五',
                src: require('../../../assets/img/partner/p_15.jpg')
                }, {
                title: '客户十三',
                src: require('../../../assets/img/partner/p_16.jpg')
                }],
        };
    },
};
</script>
<style scoped>
.client-pic{
    height: 100px;
    display: flex;
	justify-content: center; 
	align-items: center; 
    border: 1px solid #eee;
    margin-bottom: 10px;
}
.client-pic img{
    max-width: 80%;
    max-height: 60px;
}
</style>